const doc = [({"zh_cn":({"adminConstantCompanyStatus":({"contract":"合同中", "contractTerminated":"合同终止", "contractTerminationScheduled":"已排定合同终止", "preoperationalEnd":"前运算结束"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;